import { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { postBPDataWithoutParams } from 'src/business/services'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import {
  TABS_IN_CLINIC_LOCATION_ONBOARDING,
  timezones_list
} from 'src/consumer/constants'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import {
  ClinicLocationOnboardingComponent,
  ClinicLocationStaffComponent,
} from './ClinicOnboardingComponents'
import {
  BusinessOnboardingBody,
  BusinessOnboardingBodyDescription,
  BusinessOnboardingBodyHeading,
  BusinessOnboardingHeader,
  BusinessOnboardingHeaderTabs,
  BusinessOnboardingMain,
  BusinessOnboardingPage,
  BusinessOnboardingSubmitButton
} from './ClinicOnboardingStyles'
// import 'react-phone-input-2/lib/bootstrap.css'

import 'react-phone-number-input/style.css'
import { useNavigate, useParams } from 'react-router-dom'
import greenTick from 'src/assets/green_tick.png'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { getMPData } from 'src/mentor/services'
import {
  createDefaultClinicSchedule,
  validateClinicFunction,
} from '../clinicSchedule/clinic-schedule-utils'
import ClinicScheduleComponent from '../clinicSchedule/components/ClinicScheduleComponent'
import { checkIfClinicPeopleEverSaved } from './components/utils'
import { getAllContactsOfAClinicBrand } from './locationOnboardingUtils'

export const clinicStaffTypesWithJsonFields = [
  { id: 'management', title: 'Management Personnels', singleTitle: 'Management Personnel' },
  { id: 'doctors', title: 'Doctors', singleTitle: 'Doctor' },
  { id: 'therapists', title: 'Therapists', singleTitle: 'Therapist' },
  { id: 'assistants', title: 'Clinic Assistants', singleTitle: 'Clinic Assistant' },
  // { id: 'staffMemberIds', title: 'Staff Members', singleTitle: 'Staff Member' },
]

//
//
//
//

//
//
//

//
//

//
//

//

//

export default function ClinicLocationPage() {
  const { clinicBrandId } = useParams()
  const { ownerData, refreshOwnerAssociatedClinicsData } = useContext(ClinicDataContext)
  const navigate = useNavigate()

  const thisClinicBrandData = ownerData?.associatedClinicBrandsData?.find(
    (item) => item?.id === clinicBrandId,
  )

  // tab related
  const [selectedTab, setSelectedTab] = useState(TABS_IN_CLINIC_LOCATION_ONBOARDING[0]?.id)
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false)
  const [completedTabs, setCompletedTabs] = useState([])

  // clinic details related
  const [clinicLocationData, setClinicLocationData] = useState({
    enabled: true,
    apiParam: 'clinic-profile',
    clinicBrandId: clinicBrandId,
    firstName: '',
    title: '',
    name: '',
    slug: '',
    email: '',
    mobile: '',
    cloudClinic: false,
    location: {
      countryCode: 'in',
      city: '',
      address: '',
    },
    timeZone: {
      offset: '',
      title: '',
    },
  })
  // staff related
  const [staffObject, setStaffObject] = useState({ doctors: [], therapists: [], assistants: [] })

  const [teacherData, setTeacherData] = useState()

  const [invalidSchedules, setInvalidSchedules] = useState()

  async function postSchedule(url, schedule) {
    const responseSaveProfile = await postBPDataWithoutParams('/api/secure/cp/clinic/save', {
      ...clinicLocationData,
      schedules: schedule,
    })
    return responseSaveProfile
  }

  const handleNext = async () => {
    if (selectedTab === 'clinic_location_details') {
      setSubmitButtonLoading(true)
      const responseSaveProfile = await postBPDataWithoutParams('/api/secure/cp/clinic/save', {
        ...clinicLocationData,
        slug: clinicLocationData?.slug || clinicLocationData?.tempSlug,
      })
      setSubmitButtonLoading(false)
      if (
        responseSaveProfile?.status === 200 &&
        isCommonResponseSuccessful(responseSaveProfile?.data?.code) &&
        responseSaveProfile?.data?.data?.clinic
      ) {
        const savedClnData = responseSaveProfile?.data?.data?.clinic

        setClinicLocationData({
          ...(savedClnData || {}),
          schedules:
            !!savedClnData?.schedules || !!savedClnData?.schedules?.length
              ? savedClnData?.schedules
              : [
                  createDefaultClinicSchedule(clinicLocationData?.timeZone?.offset),
                ],
        })
        setSelectedTab('clinic_location_schedule')
        setCompletedTabs((prev) => {
          const newTab = TABS_IN_CLINIC_LOCATION_ONBOARDING[1]?.id
          return prev.includes(newTab) ? prev : [...prev, newTab]
        })
      } else {
        alert('Please try again')
      }
    } else if (selectedTab === 'clinic_location_schedule') {
      setSubmitButtonLoading(true)
      var scheduleValidObjects = validateClinicFunction(clinicLocationData)
      setInvalidSchedules(scheduleValidObjects.schedulesValidationArray)
      if (!scheduleValidObjects.schedules) {
        setSubmitButtonLoading(false)
        return
      }

      const responseSaveProfile = await postBPDataWithoutParams('/api/secure/cp/clinic/save', {
        ...clinicLocationData,
      })
      // const responseSaveProfile = await submitFirstScheduleWithEventFunction(
      //   clinicLocationSchedule,
      //   clinicLocationSchedule?.timeZone,
      //   undefined,
      //   { schedulePostFunction: postSchedule, schedulePostUrl: '' },
      //   clinicLocationData,
      // )
      setSubmitButtonLoading(false)
      if (
        responseSaveProfile?.status === 200 &&
        isCommonResponseSuccessful(responseSaveProfile?.data?.code) &&
        responseSaveProfile?.data?.data?.clinic
      ) {
        const savedClnData = responseSaveProfile?.data?.data?.clinic
        setClinicLocationData({
          ...savedClnData,
          ownerId: ownerData?.userProfileData?.userId,
          userId: ownerData?.userProfileData?.userId,
        })

        const clnPeopleEverSaved = checkIfClinicPeopleEverSaved({
          clinic: savedClnData,
        })

        const allStaffInBrand = getAllContactsOfAClinicBrand({
          clinicBrandData: thisClinicBrandData,
          mentorsInThisBrandData: ownerData?.ownerBrandMentorsData?.[clinicBrandId],
          peopleInThisBrandData: ownerData?.ownerBrandPeopleUserSummary?.[clinicBrandId],
        })

        setStaffObject(allStaffInBrand)

        // setStaffAccordionState(clinicStaffTypesWithJsonFields?.[0]?.id)
        // setClinicStaff((prev) => {
        //   if (prev) {
        //     return prev
        //   } else {
        //     setStaffValidation({})
        //     return {
        //       doctors: responseSaveProfile?.data?.data?.clinic?.doctors || [],
        //       management: responseSaveProfile?.data?.data?.clinic?.management || [
        //         {
        //           id: ownerData?.userProfileData?.userId,
        //           title: ownerData?.userProfileData.title,
        //           email: ownerData?.userProfileData.email,
        //         },
        //       ],
        //       supportStaff: responseSaveProfile?.data?.data?.clinic?.supportStaff || [],
        //       therapists: responseSaveProfile?.data?.data?.clinic?.therapists || [],
        //     }
        //   }
        // })
        // await sleep(200)
        setCompletedTabs((prev) => {
          const newTab = TABS_IN_CLINIC_LOCATION_ONBOARDING[2]?.id
          return prev.includes(newTab) ? prev : [...prev, newTab]
        })
        setSelectedTab('clinic_location_staff')
      }
    } else if (selectedTab === 'clinic_location_staff') {
      // if (clinicStaff?.management?.length > 0) {
      //   const responseSaveProfile = await postBPDataWithoutParams('/api/secure/cp/clinic/save', {
      //     ...clinicLocationData,
      //     ...clinicStaff,
      //   })
      //   if (responseSaveProfile.status === 200) {
      //     localStorage.removeItem('onboardingClinicUser')
      //     window.location.reload()
      //   }
      // } else {
      //   var validation = {}
      //   if (!clinicStaff?.management || clinicStaff?.management?.length === 0)
      //     validation.management = 'management personnel'
      //   setStaffValidation(validation)
      //   toast.error(`There needs to be at least one ${Object.values(validation)?.join(', ')}`)
      // }
      setSubmitButtonLoading(true)
      const toSubmitWithStaff = { ...clinicLocationData, ...staffObject }
      const responseSaveProfile = await postBPDataWithoutParams(
        '/api/secure/cp/clinic/save',
        toSubmitWithStaff,
      )
      setSubmitButtonLoading(false)
      if (
        responseSaveProfile?.status === 200 &&
        isCommonResponseSuccessful(responseSaveProfile?.data?.code) &&
        responseSaveProfile?.data?.data?.clinic
      ) {
        await refreshOwnerAssociatedClinicsData()
        navigate(`/clinic-home/${clinicBrandId}`)
      } else {
        alert('Please try again')
      }
    }
  }

  async function getDoctorData() {
    if (
      getAllRolesInBoolean().isDoctor ||
      getAllRolesInBoolean().isTeacher ||
      getAllRolesInBoolean().isCreator
    ) {
      const resp = await getMPData('/api/secure/teacher/profile')
      if (resp?.status === 200 && resp?.data) {
        if (Array.isArray(resp?.data?.categories) && resp?.data?.categories?.includes('doctor')) {
          setTeacherData(resp?.data)
          return resp?.data
        }
      }
    }
  }

  async function setInitialData() {
    getDoctorData().then((docData) => {
      setClinicLocationData((prev) => ({
        ...prev,
        location: {
          ...(prev?.location || {}),
          // city: prev?.location?.city || docData?.location?.city || '',
          city: docData?.location?.city || '',
        },
      }))
    })

    const kolkataTimeZone = timezones_list?.find((tzn) => tzn?.id === 'asia-kolkata')
    setClinicLocationData((prev) => ({
      ...prev,
      userId: ownerData?.userProfileData?.userId,
      email: ownerData?.userProfileData?.email || '',
      mobile: ownerData?.userProfileData?.mobile || '',
      timeZone: {
        offset: encodeURIComponent(kolkataTimeZone?.gmtvalue),
        title: kolkataTimeZone?.name,
      },
    }))
    if (ownerData?.associatedClinicBrandsData?.[0]?.id) {
      completedTabs.push(TABS_IN_CLINIC_LOCATION_ONBOARDING[0]?.id)
    }
    setCompletedTabs(completedTabs)
  }

  useEffect(() => {
    setInitialData()
  }, [])
  useEffect(() => {
    console.log({ clinicLocationData })
  }, [clinicLocationData])

  return (
    <BusinessOnboardingPage>
      <PublicAppHeader />
      <BusinessOnboardingMain>
        <BusinessOnboardingHeader>
          {TABS_IN_CLINIC_LOCATION_ONBOARDING?.map((item, tabIdx) => (
            <BusinessOnboardingHeaderTabs
              selected={selectedTab === item?.id}
              key={item?.id}
              onClick={
                TABS_IN_CLINIC_LOCATION_ONBOARDING?.findIndex((tab) => tab?.id === selectedTab) >
                tabIdx
                  ? () => {
                      setSelectedTab(item?.id)
                    }
                  : null
              }
              style={{ height: 'unset', padding: '5px', textAlign: 'center' }}
            >
              {TABS_IN_CLINIC_LOCATION_ONBOARDING?.findIndex((tab) => tab?.id === selectedTab) >
                tabIdx && <img src={greenTick} alt="tick" />}
              {item?.title}
            </BusinessOnboardingHeaderTabs>
          ))}
        </BusinessOnboardingHeader>

        {selectedTab === 'clinic_location_details' && (
          <ClinicLocationOnboardingComponent
            clinicLocationData={clinicLocationData}
            setClinicLocationData={setClinicLocationData}
            saveClinicLocation={handleNext}
            savingClinicLocation={submitButtonLoading}
            clinicParentBrandData={thisClinicBrandData}
          />
        )}

        {selectedTab === 'clinic_location_schedule' && (
          <BusinessOnboardingBody useMaxWidth maxWidth={'576px'}>
            <BusinessOnboardingBodyHeading>Clinic Schedule</BusinessOnboardingBodyHeading>

            <BusinessOnboardingBodyDescription>
              Let us know the schedule this location operates on.
            </BusinessOnboardingBodyDescription>
            <ClinicScheduleComponent
              teacherData={clinicLocationData}
              setTeacherData={setClinicLocationData}
              invalidSchedules={invalidSchedules}
            />
            {/* <GeneralAvailabilityComponent
              initialSchedule={clinicLocationSchedule}
              setInitialSchedule={setClinicLocationSchedule}
              showHeading={false}
            /> */}
            <BusinessOnboardingSubmitButton
              style={{ marginBottom: '20px', marginTop: '20px' }}
              onClick={handleNext}
            >
              <span>Continue</span>
              {submitButtonLoading && <Spinner animation="border" variant="light" size="sm" />}
            </BusinessOnboardingSubmitButton>
          </BusinessOnboardingBody>
        )}

        {selectedTab === 'clinic_location_staff' && (
          <ClinicLocationStaffComponent
            staffObject={staffObject}
            setStaffObject={setStaffObject}
            saveStaffFunc={handleNext}
            savingStaff={submitButtonLoading}
            peopleInThisBrandData={ownerData?.ownerBrandPeopleUserSummary?.[clinicBrandId]}
            mentorsInThisBrandData={ownerData?.ownerBrandMentorsData?.[clinicBrandId]}
            clinicParentBrandData={thisClinicBrandData}
            ownerData={ownerData}
          />
        )}
      </BusinessOnboardingMain>
    </BusinessOnboardingPage>
  )
}
